// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import Progress from "../ui/Progress";
import React from "react";
import { TestRunParams } from "./TestRunConstants";
import { useParams } from "react-router-dom";
import { useTestRunConfig } from "./useTestRunConfig";

export default () => {
  const { step } = useParams<TestRunParams>() as {
    step: string;
  };
  const { getTestRunStep } = useTestRunConfig();

  // Find how many steps are we away from the start
  let stepCount = 1;
  let marker = getTestRunStep(step);
  while (marker.nav.previous) {
    stepCount++;
    const next = getTestRunStep(marker.nav.previous);
    if (!next) {
      throw new Error(
        `Invalid previous transition: ${marker.name} -> ${marker.nav.previous}`
      );
    }
    marker = next;
  }

  // Find how many steps there is in total.
  // We do this because steps can be skipped.
  let totalSteps = stepCount;
  marker = getTestRunStep(step);
  while (marker.nav?.next?.default) {
    totalSteps++;
    const next = getTestRunStep(marker.nav.next.default);
    if (!next) {
      throw new Error(
        `Invalid default transition: ${marker.name} -> ${marker.nav.next.default}`
      );
    }
    marker = next;
  }
  return <Progress value={stepCount} max={totalSteps} />;
};
